<!--
  - Copyright (c) 2022. Haodong JU
  -->

<template>
  <v-container class="px-6">
    <v-progress-linear
      v-if="mainPageLoading"
      color="primary"
      indeterminate
    />
    <page-header>
      {{ $t('marketingStatistics') }}
    </page-header>

    <div
      class="white py-4"
      style="position: sticky;top: 0;z-index: 2"
    >
      <div
        class="d-flex align-center"
      >
        <v-item-group
          v-model="tab"
          mandatory
        >
          <div class="d-flex">
            <v-item v-slot="{active,toggle}">
              <v-btn
                max-width="220"
                :color="active?'primary':''"
                :outlined="!active"
                class="mr-2 px-4"
                style="background: white;"
                @click="toggle"
              >
                <div
                  class="hideMore"
                  style="max-width: 160px"
                >
                  {{ $t('goodsMarketingStatistics') }}
                </div>
              </v-btn>
            </v-item>
            <v-item v-slot="{active,toggle}">
              <v-btn
                :color="active?'primary':''"
                :outlined="!active"
                class="mr-2"
                style="background: white"
                @click="toggle"
              >
                <div
                  class="hideMore"
                  style="max-width: 160px"
                >
                  {{ $t('ingredientsMarketingStatistics') }}
                </div>
              </v-btn>
            </v-item>
            <v-item v-slot="{active,toggle}">
              <v-btn
                :color="active?'primary':''"
                :outlined="!active"
                style="background: white"
                @click="toggle"
              >
                <div
                  class="hideMore"
                  style="max-width: 160px"
                >
                  {{ $t('timeMarketingStatistics') }}
                </div>
              </v-btn>
            </v-item>
          </div>
        </v-item-group>
        <v-spacer/>
        <v-btn
          class="mr-0"
          elevation="0"
          outlined
          style="background: white"
          @click="showDatePicker=true"
        >
          <v-icon left>
            mdi-calendar
          </v-icon>
          {{ getNiceLabel(dates) }}
        </v-btn>
      </div>
    </div>
    <v-card
      elevation="0"
    >
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <dish-statistic-fragment :sales-data="salesData"/>
        </v-tab-item>
        <v-tab-item>
          <topping-statistic :sales-data="toppingSalesData"/>
        </v-tab-item>
        <v-tab-item>
          <turn-over-fragment :span-turnover="spanTurnover"/>
        </v-tab-item>
      </v-tabs-items>
    </v-card>

    <v-dialog
      v-model="showDatePicker"
      max-width="400px"
    >
      <v-card
        class="pa-4 pb-4"
        color="#f6f6f6"
        elevation="0"
        tile
      >
        <date-range-picker v-model="dateInput"/>
        <div class="px-2 mt-2">
          <v-btn
            block
            color="primary"
            elevation="0"
            large
            @click="dateSubmit"
          >
            {{ $t('sure') }}
          </v-btn>
          <v-btn
            block
            class="mt-2"
            color="error"
            large
            outlined
            @click="showDatePicker=false"
          >
            {{ $t('cancel') }}
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>

  import DateRangePicker from '@/composable/DateRangePicker'
  import { getNiceLabel, today } from '@/common/Repository/DateRepository'
  import { loadDashboardData } from '@/common/common'
  import DishStatisticFragment from '@/views/AadenPages/statistic/childPage/DishStatisticFragment'
  import ToppingStatistic from '@/views/AadenPages/statistic/childPage/ToppingStatisticFragment'
  import TurnOverFragment from '@/views/AadenPages/statistic/childPage/TurnOverFragment'
  import PageHeader from '@/composable/InK/typography/PageHeader'

  export default {
    components: {
      PageHeader,
      TurnOverFragment,
      ToppingStatistic,
      DishStatisticFragment,
      DateRangePicker,
    },
    data: function () {
      return ({
        dateInput: [today, today],
        dates: [today, today],

        showDatePicker: false,
        dashboardData: null,
        tab: 0,
        mainPageLoading: false,
      })
    },
    computed: {
      salesData () {
        return this.dashboardData?.dishStatistic ?? []
      },
      toppingSalesData () {
        return this.dashboardData?.attributeSales ?? []
      },
      spanTurnover () {
        return this.dashboardData?.spanTurnover
      },
    },
    watch: {
      dates: function (val) {
      },
    },
    async mounted () {
      await this.loadData()
    },
    methods: {
      getNiceLabel,
      async dateSubmit () {
        this.showDatePicker = false
        this.dates = this.dateInput
        await this.loadData()
      },
      async loadData () {
        this.mainPageLoading = true
        this.dashboardData = (await loadDashboardData(...this.dates))
        this.mainPageLoading = false
      },
    },
  }
</script>
